/**
 * PHSIMS Developer Portal — Entry Point
 *
 * Completely independent React app. No React-Admin, no admin backend deps.
 * Authenticates via X-API-Key against /v1/me/* endpoints.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import App from './App';

const theme = createTheme({
  palette: {
    primary:   { main: '#0d5c2e' },
    secondary: { main: '#ef7d00' },
  },
  typography: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
});

// Remove loading screen
const loader = document.getElementById('loading-screen');
if (loader) {
  loader.classList.add('fade-out');
  setTimeout(() => loader.remove(), 400);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>,
);
